import { SearchAnalytics } from "../utils/analytics/analytics-search";
import { debounce } from "@sazka/utils/debounce";
import { SecurityUtils } from "@sazka/utils/security-utils";
import { UrlUtils } from "@sazka/utils/url";
import { Loader } from "@sazka/design-system/src/loader/loader";
interface SearchObject {
    category: string;
    title: string;
    imageUrl: string;
    type: string;
    url: string;
    externalSystemId: number;
}

interface SearchResponse {
    value: Array<SearchObject>;
}

let submitButton: JQuery;
let searchBox: JQuery;
let container: JQuery;
let autocompleteElement: JQuery;
let searchButton: JQuery;
let searchText: string;
// eslint-disable-next-line
let initialized = false;
const isSearchResultPage = environment?.nodeAliasPath === "/vyhledavani";
let isMobileMode: boolean;
// eslint-disable-next-line
let clickInside = false;

const mobileMode = (): boolean => {
    return window.innerWidth < 960;
};

const autocomplete = (searchText: string) => {
    return $.getJSON("/api/search", { searchText });
};

const hideAutocomplete = () => {
    autocompleteElement.html("");
};

const adjustUrl = (url: string) => {
    return url.indexOf("/") == 0 ? url.substr(1) : url;
};

const markdownTip = (data: SearchObject) => {
    const button = data.externalSystemId
        ? `<span class='search-tip__btn btn btn-primary btn-no-hover'>${
              data.type === "game" ? "Hrát hru" : "Setřít los"
          }</span>`
        : "";
    const attributes = data.externalSystemId
        ? ` search-tip--game game-launcher' data-game-id='${data.externalSystemId}'`
        : `' href='/${adjustUrl(data.url)}'`;

    return `
        <a class='search-tip${attributes} data-a-gametype='${data.type}'>
            ${button}
            ${data.imageUrl ? `<img src='${data.imageUrl}' alt='' class='search-tip__img' />` : ""}
            <span class='search-tip__name'><span class='search-tip__category'>${data.category}</span>${
        data.title
            ? `<span class="search-tip__slash"> / </span><span class='search-tip__title'>${data.title}</span>`
            : ""
    }</span>
        </a>`;
};

const printResults = (data: Array<SearchObject>) => {
    autocompleteElement.html(data.map(markdownTip).join(""));
};

const markdown = () => {
    return `<div class="quick-search${isSearchResultPage || isMobileMode ? " quick-search--permanent" : ""}${
        isMobileMode ? " quick-search--mobile" : " quick-search--desktop"
    }">
                    <div class="quick-search__box">
                        <input type="search" autocomplete="off" class="form-control quick-search__input" placeholder="Vyhledávání ..." maxlength="32" id="quick-search-input" value="${SecurityUtils.sanitize(
                            UrlUtils.getQueryString("searchtext") ?? ""
                        )}" />
                        <div class="quick-search__autocomplete-container" id="quick-search-autocomplete-container">
                            <div class="quick-search__autocomplete" id="quick-search-autocomplete"></div>
                            <a href="/vyhledavani" class="quick-search__button" id="quick-search-button">Zobrazit všechny výsledky</a>
                        </div>
                    </div>
                    <button type="button" class="quick-search__submit" id="quick-search-submit" aria-label="Hledat">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" stroke="#fff" fill="none" stroke-linejoin="round" stroke-width="1.5">
                            <path d="M16 8.5a7.5 7.5 0 1 1-15 0 7.5 7.5 0 1 1 15 0z"></path>
                            <path d="M14 14l4 4" stroke-linecap="round"></path>
                        </svg>
                    </button>
                </div>`;
};

const searchUrl = (searchText: string) => `/vyhledavani?searchtext=${searchText}&searchmode=anyword`;

const search = () => {
    searchText = searchBox.val().toString();
    if (!searchText) return;

    searchText = limitSearchText(searchText);
    Loader.show();
    window.location.href = searchUrl(searchText);
};

const hideSearch = () => {
    searchBox.val("");
    searchText = "";
    container.removeClass("active non-empty default-autocomplete");
};

const showSearch = () => {
    container.addClass("active");
};

let lastSearchedText = "";
let lastResults = [];

const handleResultsDebounce = debounce(() => {
    autocomplete(searchText).then((data: SearchResponse) => {
        lastSearchedText = searchText;
        lastResults = data.value;
        data.value?.length ? printResults(data.value) : hideAutocomplete();
    });
}, 200);

const handleAnalyticsDebounce = debounce(() => {
    if (lastSearchedText) {
        SearchAnalytics.pushSearchSuggester("main", lastSearchedText, lastResults?.length);
    }
}, 1000);

const onInput = () => {
    searchText = searchBox.val().toString() || "";
    searchText = limitSearchText(searchText);
    if (searchText.length <= 0) {
        container.removeClass("non-empty");
    } else {
        container.addClass("non-empty");
        searchButton.attr("href", searchUrl(searchText));
    }

    if (searchText.length < 3) {
        hideAutocomplete();
        return;
    }

    handleResultsDebounce();
    handleAnalyticsDebounce();
};

const showDefaultAutocomplete = () => {
    container.addClass("default-autocomplete");
    printResults(quickSearchResults);
};

const searchClick = () => {
    const isOpen = container.hasClass("active");

    if (isOpen) {
        search();
        hideSearch();
        hideAutocomplete();
    } else {
        showSearch();
        searchBox.focus();
    }
};

const keyUpHandler = (e) => {
    if (e.key == "Enter") {
        e.preventDefault();
        search();
    }
};

const searchBoxClickHandler = () => {
    if (!searchText) {
        showDefaultAutocomplete();
    }
};

const documentClickHandler = () => {
    if (clickInside) {
        clickInside = false;
        return;
    }
    hideAutocomplete();
    if (!isSearchResultPage) {
        hideSearch();
    }
};

const containerClickHandler = () => {
    // e.stopPropagation();
    clickInside = true;
};

const autocompleteClickHadler = (event) => {
    const searchTip = (event.target as HTMLElement).closest("a");
    const category = searchTip.querySelector(".search-tip__category")?.textContent;
    const title = searchTip.querySelector(".search-tip__title")?.textContent;
    const gametype = searchTip.getAttribute("data-a-gametype");
    const name = `${category}${title ? `.${title}` : ""}`;
    SearchAnalytics.pushSuggesterClick(SearchAnalytics.getVerticalByCategory(gametype), name);
    hideAutocomplete();
    if (!isSearchResultPage) {
        hideSearch();
    }
};

const headerHiddenHandler = () => {
    hideAutocomplete();
    container.removeClass("non-empty default-autocomplete");
};

const init = () => {
    initialized = true;
    searchBox = $("#quick-search-input");
    autocompleteElement = $("#quick-search-autocomplete");
    container = searchBox.closest(".quick-search");
    searchButton = $("#quick-search-button");

    searchBox[0]?.removeEventListener("input", onInput);
    searchBox[0]?.addEventListener("input", onInput);

    searchBox[0]?.removeEventListener("keyup", keyUpHandler);
    searchBox[0]?.addEventListener("keyup", keyUpHandler);

    searchBox.off("click", searchBoxClickHandler);
    searchBox.on("click", searchBoxClickHandler);

    $(document).off("click", documentClickHandler);
    $(document).on("click", documentClickHandler);

    // TODO: make better "click off" - this is stopping games from launching
    container.off("click", containerClickHandler);
    container.on("click", containerClickHandler);

    autocompleteElement.off("click", "a", autocompleteClickHadler);
    autocompleteElement.on("click", "a", autocompleteClickHadler);

    document.getElementById("header")?.removeEventListener("header-hidden", headerHiddenHandler);
    document.getElementById("header")?.addEventListener("header-hidden", headerHiddenHandler);
};

const onResize = debounce(() => {
    const newMobileMode = mobileMode();
    if (newMobileMode == isMobileMode) {
        return;
    }

    $(".quick-search").remove();
    setup();
}, 60);

function setup() {
    if (!$("#header").length) {
        return;
    }
    initialized = false;
    isMobileMode = mobileMode();
    if (isMobileMode && $("#mainMenu").length) {
        $("#mainMenu").prepend(markdown());
    } else if ($("#user-menu").length) {
        $("#user-menu").before(markdown());
    }

    submitButton = $("#quick-search-submit");

    // init on vyhledavani
    if (isSearchResultPage || isMobileMode) {
        init();
        container.addClass("active");
    }

    submitButton.click(() => {
        if (!initialized) {
            init();
        }
        searchClick();
    });

    // todo do only once
    $(window).off("resize", onResize);
    $(window).resize(onResize);
}

function limitSearchText(text: string | null | undefined) {
    if (!text) return text;
    return text.substring(0, 32);
}

export function useSearch() {
    setup();
}
